module.exports = __webpack_public_path__ + "img/bg1.55e5d9be.png";